exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categories-dropdown-main-item[data-v-10c9df98]{transition:background-color .1s,color .1s}.categories-dropdown-main-item[data-v-10c9df98]:hover{background-color:#2160c4;color:#fff}.categories-dropdown-item[data-v-10c9df98]:hover{text-decoration:underline}", ""]);

// exports
